// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"o3-z","colorTextValue":"p3-z","swatches":"q3-z","collapseLink":"r3-z","isCollapsed":"s3-z","dropdown":"t3-z","disabled":"u3-z"};